import { combineReducers } from "redux";
import getAll from "./get-all";
import getOne from "./get-one";

const user = combineReducers({
  getAll,
  getOne,
});

export default user;
